module.exports = __webpack_public_path__ + "static/media/gameDetailScreenshot1.89cc3809.jpg";